import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

// list -------------------------------------------------------------
const list = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/tracks', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const listAll = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/tracks', method: 'get', headers: authHeader()
    }).then(response => {
        if (response.status !== 200) {
            return [];
        } else {
            return response.data;
        }
    }).catch(function (error) {
        console.log(error.response.data);
        return [];
    })
}

// save -------------------------------------------------------------
const save = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/tracks/', method: 'post', headers: authHeader(), data: data
    })
}

/* -------------------------------------------------------------------------------- *\
|                               trackdelete
\* -------------------------------------------------------------------------------- */
const trackdelete = async (uuid) =>
{
    return await axios({url: getmainurl() + '/api/v1/tracks/' + uuid, method: 'delete', headers: authHeader()})
}

/* -------------------------------------------------------------------------------- *\
|                               getContent
\* -------------------------------------------------------------------------------- */
const getContent = async (uuid) =>
{
    return await axios({ url: getmainurl() + '/api/v1/tracks/content/' + uuid, method: 'get', headers: authHeader() });
}
/* -------------------------------------------------------------------------------- *\
|                               getContentCentral
\* -------------------------------------------------------------------------------- */
const getContentCentral = async (sic, code) =>
{
    return await axios({ url: getmainurl() + '/api/v1/tracks/central-content/' + sic + '/' + code, method: 'get', headers: authHeader() });
}

const get = async (uuid) => {
    return await axios({
        url: getmainurl() + '/api/v1/tracks/' + uuid, method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const getByCodeAndVenue = async (code, venueCode) => {
    return await axios({
        url: getmainurl() + `/api/v1/venues/${venueCode}/tracks/${code}`,
        method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

/* -------------------------------------------------------------------------------- *\
|                               getSynchro
\* -------------------------------------------------------------------------------- */
const getSynchro = async () =>
{
    return axios({ url: getmainurl() + '/api/v1/tracks/synchro', method: 'get', headers: authHeader() });
}
/* -------------------------------------------------------------------------------- *\
|                               synchronize
\* -------------------------------------------------------------------------------- */
const synchronize = async (sic, code, distance, type) =>
{
    const data = { venueCode:sic, code, distance, type, label: '' };
    return await axios({ url: getmainurl() + '/api/v1/tracks/central-synchro', method: 'post', headers: authHeader(), data: data });
}
/* -------------------------------------------------------------------------------- *\
|                               check_integrity
\* -------------------------------------------------------------------------------- */
const check_integrity = async () =>
{
    return await axios({ url: getmainurl() + '/api/v1/tracks/check-integrity', method: 'get', headers: authHeader() })
        .then(response => response.data);
}

// default export ---------------------------------------------------
const track = {
    list,
    listAll,
    save,
    trackdelete,
    get,
    getByCodeAndVenue,
    getContent,
    getContentCentral,
    getSynchro,
    synchronize,
    check_integrity
};

export default track;